module.exports = __webpack_public_path__ + "img/step28_withe_lebel.2a014990.png";